'use strict';


$(document).ready(function () {
    const $tabs = $('.tab');
    const $contents = $('.content-onglet');
    const $containerInfo = $('.tabs').parents('.product-info');

    var tabCount = $('.product-info .tab').length;

    if ($(window).width() > 840) {

        if (tabCount === 1) {
            $('.product-info .tab').css('width', '100%');
        } else if (tabCount === 2) {
            $('.product-info .tab').css('width', '50%');
        } else if (tabCount === 3) {
            $('.product-info .tab:first-child').css('width', '33%');
            $('.product-info .tab:nth-child(2)').css('width', '34%');
            $('.product-info .tab:last-child').css('width', '33%');
        } else if (tabCount === 4) {
            $('.product-info .tab').css('width', '25%');
        }
    }

    // Vérifier le nombre d'onglets visibles
    if ($tabs.length <= 1) {
        // Si un seul onglet ou moins, masquer la barre d'onglets
        $tabs.parents('.tabs-wrapper').removeClass('d-flex').addClass('d-none');
    } else {
        // Initialiser le premier onglet actif
        $('.tabs .tab').first().addClass('show-first');
        $('.tab-content .content-onglet').first().addClass('first-content-show');
        $('.show-first').addClass('active');
        $('.first-content-show').addClass('active fade in').show();
        $tabs.parents('.tabs-wrapper').removeClass('d-none').addClass('d-flex');

        // Gérer le clic sur les onglets
        $tabs.on('click', function () {
            const $tab = $(this);
            const targetId = $tab.data('tab');

            if ($tab.hasClass('active')) return;

            $tabs.removeClass('active');
            $tab.addClass('active');

            $contents.filter('.active').removeClass('active').fadeOut(50, function () {
                $('#' + targetId)
                    .addClass('active')
                    .fadeIn(100);
            });
            $contents.filter('.active').removeClass('fade in').fadeOut(100, function () {
                $('#' + targetId)
                    .addClass('fade in')
                    .fadeIn(100);
            });
            if ($(window).width() < 840) {
                setTimeout(function () {
                    $(".informations-Product .videos").slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true,
                        arrows: false,
                        responsive: [
                            {
                                breakpoint: 840,
                                settings: {
                                    slidesToShow: 1,
                                    infinite: true
                                }
                            }
                        ]
                    });
                }, 200);
            }
        });
    }

    var $buttonShowMore = $containerInfo.data('show-more');
    var $buttonShowLess = $containerInfo.data('show-less');

    $('.text-block .slide-read-more').expander({
        slicePoint: 500,
        expandText: $buttonShowMore,
        userCollapseText: $buttonShowLess,
        expandEffect: 'slideDown',
        collapseEffect: 'slideUp',
        expandSpeed: 0,
        collapseSpeed: 0
    });
});


$(".videos .info-videos a").each(function () {
    $(this).on("click", function (e) {
        e.preventDefault();

        var titleVideo = $(this).find(".title-video").text();
        var linkVideo = $(this).attr("href");

        var videoId = linkVideo.split("v=")[1];
        var ampersandPosition = videoId.indexOf("&");
        if (ampersandPosition !== -1) {
            videoId = videoId.substring(0, ampersandPosition);
        }

        var iframeLink = `https://www.youtube.com/embed/${videoId}`;

        $(".show-video-info .modal-body .title-video").html(titleVideo);

        var contentVideo = `<iframe width="536" height="302" src="${iframeLink}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;

        $(".show-video-info .modal-body .iframe-video").empty().html(contentVideo);
    });
});

$('.videos').on('init reInit afterChange', function () {
    $(".videos .info-videos a").off("click").on("click", function (e) {
        e.preventDefault();

        var titleVideo = $(this).find(".title-video").text();
        var linkVideo = $(this).attr("href");

        var videoId = linkVideo.split("v=")[1];
        var ampersandPosition = videoId.indexOf("&");
        if (ampersandPosition !== -1) {
            videoId = videoId.substring(0, ampersandPosition);
        }

        var iframeLink = `https://www.youtube.com/embed/${videoId}`;

        $(".show-video-info .modal-body .title-video").html(titleVideo);

        var contentVideo = `<iframe width="536" height="302" src="${iframeLink}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;

        $(".show-video-info .modal-body .iframe-video").empty().html(contentVideo);
    });
});
